import { QueryClientProvider } from "@tanstack/react-query";
import React, { StrictMode } from "react";
import { queryClient } from "./lib/queryClient";
import { ThemeProvider } from "@mui/material";
import { theme } from "./lib/themes";
import { RouterProvider } from "react-router-dom";
import { router } from "./lib/router";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const App = () => {
  const NODE_ENV = process.env.REACT_APP_ENV;
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <RouterProvider router={router} />
          {NODE_ENV === "development" && (
            <ReactQueryDevtools initialIsOpen={false} position="bottom" />
          )}
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>
  );
};

export default App;
